import type { SwiperOptions } from 'swiper/types/swiper-options';
import type { AImageProps } from '../../atoms/AImage/AImage.types';
import type { MContentHeaderItem } from '../../molecules/MContentHeader/MContentHeader.types';

export enum OCarouselTriptychImageOrientation {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

export enum OCarouselTriptychControlType {
  Dots = 'Dots',
  Numbers = 'Numbers',
  /** @deprecated Use `Numbers` instead. `Digits` is the legacy AEM dialog value and will be removed once the AEM dialog is updated. */
  Digits = 'Digits',
}

export interface MCarouselControlsConfig {
  type?: OCarouselTriptychControlType | `${OCarouselTriptychControlType}`;
  imageOverlay?: boolean | string;
}

export interface OCarouselTriptychProps {
  images: AImageProps[];
  onSlideChange?: (index: number) => void;
  onSlideClick?: (index: number) => void;
  spaceBetween?: number;
  imageOrientation?: OCarouselTriptychImageOrientation;
  mContentHeader: MContentHeaderItem;
  mCarouselControls?: MCarouselControlsConfig;
  swiperOptions?: Partial<SwiperOptions>;
  className?: string;
}
